import * as React from 'react';
import { Avatar, Box, ButtonBase, Card, Menu, MenuItem, Typography } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { apiBaseUrl } from '../utils/Api/Api';
import { currency } from './building_blocks/Currency';

/* Icons */
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import StoreIcon from '@mui/icons-material/Store';
import { layoutCardRadius, layoutShopSheetRadius } from '../theme/colors';

const OrderCard = ({ order, handleCardClick }) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleMenuClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    event?.stopPropagation();
    setAnchorEl(null);
  };

  const handleViewOrder = (event) => {
    event.stopPropagation();
    handleClose(event);
    handleCardClick();
  };

  const handleViewShop = (event) => {
    event.stopPropagation();
    handleClose(event);
    navigate(`/provider/${order.provider.id}`);
  };

  const statusLabels = {
    open: 'Esperando comerciante aceitar',
    pending: 'Pagamento pendente',
    paid: 'Esperando entregador',
    accepted: 'Esperando entregador',
    courier: 'Em entrega',
    delivered: 'Entregue',
    shipped: 'Entregue',
    done: 'Finalizado',
    failed: 'Pagamento falhou',
    rejected: 'Cancelado',
    canceled: 'Cancelado',
  };

  const providerLogo = order.provider_business_logo && `${apiBaseUrl}${order.provider_business_logo}`;
  const statusLabel = statusLabels[order.status] || order.status;
  const itemCount = order.order_items?.reduce((total, item) => total + Number(item.quantity || 0), 0) || 0;

  const formatOrderDate = () => {
    const dateMatch = order.date?.match(/^(\d{2})\/(\d{2})\/\d{2} às (\d{2}):(\d{2})/);
    const monthNames = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

    if (dateMatch) {
      const [, day, month, hour, minute] = dateMatch;
      return `${day}/${monthNames[Number(month) - 1]} às ${hour}h${minute}`;
    }

    return order.date;
  };

  const menuItemIcon = {
    width: '16px',
    height: '16px',
    color: '#90A4AE'
  };

  return (
    <Card sx={{ alignSelf: 'stretch', borderRadius: layoutShopSheetRadius }}>
      <Box sx={{ display: 'flex', p: 3, gap: 2, alignItems: 'flex-start' }}>
        <Avatar
          src={providerLogo}
          sx={{ width: '40px', height: '40px', bgcolor: '#CFD8DC', flexShrink: 0 }}
        />

        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1, flex: 1, minWidth: 0, textAlign: 'left' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', alignSelf: 'stretch', gap: 2 }}>
            <Typography variant="storeName" sx={{ color: '#263238' }}>
              {order.provider.name}
            </Typography>

            <ButtonBase
              onClick={handleMenuClick}
              sx={{display: 'flex', p: 0.5, gap: '10px', alignItems: 'center', borderRadius: '50%', bgcolor: 'surface.muted', color: 'text.secondary', cursor: 'pointer',
                '&:hover': {
                  bgcolor: '#CFD8DC',
                  color: '#263238',
                }
              }}>
              <MoreVertIcon />
            </ButtonBase>
          </Box>

          <Typography sx={{fontFamily: 'Nunito', fontSize: '14px', fontWeight: 400, lineHeight: '21px', color: '#546E7A' }}>
            {formatOrderDate()} • {currency(order.total_amount)} ({itemCount} {itemCount === 1 ? 'item' : 'itens'})
          </Typography>

          <Box sx={{ display: 'flex', height: '24px', p: 1, alignItems: 'center', gap: '10px', borderRadius: layoutCardRadius, bgcolor: 'surface.muted' }}>
            <Typography sx={{ fontFamily: 'Nunito', fontSize: '14px', fontWeight: 400, lineHeight: '21px', color: '#546E7A' }} >
              {statusLabel}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        disableScrollLock={true}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          sx: {
            display: 'inline-flex',
            alignItems: 'center',
            borderRadius: layoutCardRadius
          }
        }}
      >
        <MenuItem sx={{ display: 'flex', gap: 1, alignItems: 'center' }} onClick={handleViewOrder}>
          <ReceiptLongIcon sx={menuItemIcon} />
          <Typography>Ver pedido</Typography>
        </MenuItem>
        <MenuItem sx={{ display: 'flex', gap: 1, alignItems: 'center' }} onClick={handleViewShop}>
          <StoreIcon sx={menuItemIcon} />
          <Typography>Ver loja</Typography>
        </MenuItem>
      </Menu>
    </Card>
  );
};

export default OrderCard;
